export const fonts = {
  large: '52px',
  mediumLarge: '40px',
  medium: '32px',
  regularLarge: '24px',
  regular: '20px',
};
